import { XIcon } from '@primer/octicons-react';
import { Box, IconButton, UnderlineNav } from '@primer/react';
import { useDispatch, useSelector } from 'react-redux';
import TextWithEllipse from '../../components/ui/text-with-ellipse';
import UserAvatar from '../../components/user-avatar';
import { thuPhiTabAction } from '../../state/actions/thu-phi-tab/thuPhiTabAction';
import { RootState } from '../../state/reducers';

const HOC_SINH_TAB_ID = "hoc-sinh";

const ThuPhiTabs = () => {
    const { tabs, selectedId } = useSelector((x: RootState) => x.thuPhiTab);
    const dispatch = useDispatch();
    return (
        <Box sx={{ width: "100%" }}>
            <UnderlineNav aria-label='tabs' key={tabs.map(x => x.id).join(";")}>
                <UnderlineNav.Item 
                    aria-current={(!selectedId || selectedId === HOC_SINH_TAB_ID) ? "page" : undefined}
                    onClick={() => {
                        dispatch(thuPhiTabAction.CHANGEG_SELECTED_TAB(HOC_SINH_TAB_ID));
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", minWidth: "100px", maxWidth: "250px" }}>
                        <Box sx={{ flex: 1, overflow: "hidden", whiteSpace: "nowrap", textAlign: "left" }}>
                            <TextWithEllipse text="Học sinh" lineNumber={1} />
                        </Box>
                    </Box>
                </UnderlineNav.Item>
                {tabs.map((tab, idx) => {
                    return (
                        <UnderlineNav.Item aria-current={tab.id === selectedId ? "page" : undefined} key={tab.id} id={tab.id} onClick={() => {
                            dispatch(thuPhiTabAction.CHANGEG_SELECTED_TAB(tab.id))
                        }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", minWidth: "150px", maxWidth: "300px" }}>
                                <Box sx={{ mr: 2, mt: 1, flexShrink: 0 }}>
                                    <UserAvatar fullName={tab.title} />
                                </Box>
                                <Box sx={{ flex: 1, overflow: "hidden", whiteSpace: "nowrap", textAlign: "left", minWidth: 0 }}>
                                    <TextWithEllipse text={tab.title} lineNumber={1} />
                                </Box>
                                <Box sx={{ m: 0, mt: -3, mb: -3, mr: 0, flexShrink: 0 }}>
                                    <IconButton aria-label='delete' icon={XIcon}
                                        variant='invisible'
                                        size='small'
                                        onClick={() => {
                                            dispatch(thuPhiTabAction.REMOVE_TAB(tab.id));
                                        }}
                                    />
                                </Box>
                            </Box>
                        </UnderlineNav.Item>
                    );
                })}
            </UnderlineNav>

        </Box>
    );
};

export default ThuPhiTabs;